export default {
	section_main_banner: {
		title: {
			one: '力を与える',
			two: 'あなたの',
			three: '取引',
			four: 'で',
			five: '暗号資産',
			six: '取引',
		},
		description: {
			one: '当社のプラットフォームでは、支払いをすぐにシームレスに行うことができます、',
			two: '暗号資産を交換する必要なく - スピード、',
			three: 'セキュリティ＆利便性を確保します。',
		},
		cta_buttons: {
			one: 'はじめる',
			two: 'アプリをダウンロード',
		},
	},
	section_safety_speed: {
		cards: {
			secure_payment: {
				title: '安全な支払い',
				description: 'JPWorldPayはQRコード取引中にあなたの情報を開示しません。',
			},
			any_company: {
				title: 'どの会社でも',
				description:
					'24時間いつでも、どこでもオフライン加盟店で即座に安全に支払いができます。',
			},
			touch_free: {
				title: 'タッチフリー',
				description:
					'現金やクレジットカードを気にする必要はありません - アプリを開いて支払うだけです。',
			},
		},
		fastest_payment: {
			label: '最速の決済システム',
			title: {
				one: 'JPWorldPayの',
				two: '安全性',
				three: '＆',
				four: 'スピード',
				five: '同時に実現',
			},
			description:
				'ブロックチェーン技術の実証された安定性とJPWorldPayの独自のプラットフォームのイノベーションを組み合わせた、最速で最も信頼性の高い決済システムを体験してください。かつてない速度、セキュリティ、シームレスな取引を提供します。',
		},
		registration: {
			title: '無料登録',
			description:
				'メールアドレスとビジネスに関する基本的な情報だけが必要です。',
		},
		start_payment: {
			title: '支払いを開始',
			description:
				'メールアドレスと会社名を確認し、アカウントをリンクすれば、最初の販売準備は完了です。',
		},
		cta_button: '登録を開始する',
	},
	section_we_offer: {
		title: {
			one: 'どこでもショッピングを楽しむ',
			two: '無料で',
			three: '提供します',
		},
		description:
			'JPWorldPayは最高の技術、最高のサービス、最高のプラットフォームを完全に無料で提供します。プレミアム価格なしでプレミアム機能を体験してください。初期費用なしでビジネスを成長させましょう。シームレスで安全な決済の未来に今すぐ参加してください。',
		enjoy_shopping: {
			title: 'どこでもショッピングを楽しむ',
			description: 'JPWorldPayウォレットに保存された暗号資産で',
			boxes: {
				one: {
					title: '理想的な暗号資産ウォレット',
					description: {
						one: 'JPWorldPayで希望する',
						two: '暗号資産ウォレットを作成',
					},
				},
				two: {
					title: 'よりスマートなショッピング',
					description: {
						one: 'ショッピング時は',
						two: 'JPWorldPayをご利用ください',
					},
				},
				three: {
					title: '私たちと一緒に支払う',
					description: {
						one: 'JPWorldPayで希望する',
						two: '暗号資産で支払い',
					},
				},
			},
			cta_button: '無料アカウントを作成',
		},
	},
	section_payment_free: {
		desktop: {
			label: '最速の決済システム',
			title: {
				one: '世界中',
				two: 'どこでも',
				three: '利用可能',
			},
			descriptionFirst:
				'JPWorldPayはクレジットカード不要のシームレスで柔軟な決済体験を提供します。オンラインショッピングでも店頭でも、Wi-Fi接続があれば簡単なQRコードで即座に支払いができます。',
			descriptionSecond:
				'JPWorldPayはキオスクやPOS端末を通じたオフライン決済もサポートしており、カードなしでいつでもどこでも取引を完了できます - 手間なく、迅速で安全な支払いを実現します。',
			cta_button: '無料で始める',
		},
		mobile: {
			label: 'どこでもショッピングを楽しむ',
			title: {
				one: 'ビジネスメンバーは',
				two: '無料',
			},
			description:
				'JPWorldPayはクレジットカード不要で利用できます。Wi-Fiに接続するだけでQRコードで即座に支払い可能 - キオスクやPOS端末でのオフライン決済にも対応。',
			cta_button: 'ビジネスストアを開設',
		},
	},
	section_business_anywhere: {
		label: 'どこでもショッピングを楽しむ',
		title: {
			one: '無料',
			two: 'ビジネスメンバー向け',
		},
		description:
			'JPWorldPayはクレジットカード不要で利用できます。Wi-Fiに接続するだけでQRコードで即座に支払い可能 - キオスクやPOS端末でのオフライン決済にも対応。',
		cta_button: 'ビジネスストアを開設',
		advantage: {
			label: '最速の決済システム',
			title: {
				one: 'JPWorldPayと',
				two: '一緒なら',
				three: '多くの',
				four: '利点が',
				five: 'あります',
			},
			description:
				'JPWorldPayはクレジットカード不要で利用できます。Wi-Fiに接続するだけでQRコードで即座に支払いが可能で、キオスクやPOS端末でのオフライン決済にも対応しています。',
			payment_methods: {
				qr_code: {
					title: 'QRコード決済',
					description: 'QRコードで簡単支払い',
				},
				onetether: {
					title: 'JPWorldPay決済',
					description: 'どこでも支払い可能',
				},
				kiosk: {
					title: 'キオスク & POS端末',
					description: '便利なオフライン決済',
				},
			},
			cta_button: 'ショッピングと支払い方法',
		},
	},
	section_question: {
		label: 'よくある質問',
		title: {
			one: 'お客様の声を',
			two: '聞かせてください',
		},
		description:
			'JPWorldPayではお客様からのフィードバックを大切にし、それを行動に移しています。実際のユーザーの声に耳を傾け、それに基づいて改善することで、私たちのサービスが常に関連性を保ち、使いやすく、お客様のニーズに合わせて構築されることを保証します。',
		cta_button: 'Q&Aを始める',
	},
	section_growth: {
		stats: {
			total_customers: {
				value: '800k',
				label: '総顧客数',
			},
			customer_satisfaction: {
				value: '99.90%',
				label: '顧客満足度',
			},
			money_managed: {
				value: '260b',
				label: '運用資産',
			},
		},
	},
	section_testimonials: {
		subtitle: 'JPWorldPayに対するお客様の声',
		title: {
			one: '140万人以上の',
			two: '満足いただいているお客様が',
			three: '信頼する',
			four: '私たちのサービス',
		},
		testimonial_card: {
			description:
				'JPWorldPayは私が今まで使用した中で最高の決済プラットフォームです。とても使いやすく、カスタマーサービスも素晴らしいです。',
			author: {
				name: 'ジョン・ドウ',
				role: 'CEO, JPWorldPay',
			},
		},
	},
	section_newsletter: {
		label: 'ニュースレター購読',
		title: {
			one: '購読して',
			two: '最新情報をゲット',
		},
		description: {
			one: '購読すると、JPWorldPayのお得な情報やアップデートを直接受け取れます。',
			two: 'JPWorldPayのソリューションがあなたのビジネスをどのように成長させるか、お問い合わせください。',
		},
		form: {
			placeholder: 'メールアドレス',
			button: '今すぐ購読',
		},
	},
};
